import React from 'react';


const CLASS_NAMES = {
    LOADING_SKELETON: 'loading-skeleton'
};

function NavigationSkeleton() {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginTop: '2em',
                marginBottom: '2em',
                width: '100%',
            }}
        >
            <div>
                {/* Products count */}
                <div
                    className={CLASS_NAMES.LOADING_SKELETON}
                    style={{
                        width: '250px',
                    }}
                />
            </div>
            <div
                className={CLASS_NAMES.LOADING_SKELETON}
                style={{ width: '260px' }}
            />
            <div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    {/* Pages navigation */}
                    <div
                        className={CLASS_NAMES.LOADING_SKELETON}
                        style={{
                            width: '150px',
                            marginRight: '.5em',
                        }}
                    />
                    {/* Card view */}
                    <div
                        className={CLASS_NAMES.LOADING_SKELETON}
                        style={{
                            width: '40px',
                            marginRight: '.5em',
                        }}
                    />
                    {/* List view */}
                    <div
                        className={CLASS_NAMES.LOADING_SKELETON}
                        style={{ width: '40px' }}
                    />
                </div>
            </div>
        </div>
    );
}

export default NavigationSkeleton;